import AxiosClient from "../../services/axios.services";

class VaccinesServices {
  getVaccines = (params, type) =>
    AxiosClient.get(type === 1 ? `/api/app/Formal_Vacuna/` : `/api/app/Funcional_Vacuna/`, {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  saveVaccines = (data, type) =>
    AxiosClient.post(type === 1 ? `/api/app/Formal_Vacuna/` : `/api/app/Funcional_Vacuna/`, data, {
      headers: { "Content-Type": "application/json" },
    });
  editVaccines = (id, data, type) =>
    AxiosClient.put(type === 1 ? `/api/app/Formal_Vacuna/${id}/` : `/api/app/Funcional_Vacuna/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });
  deleteVaccines = (id, type) =>
    AxiosClient.delete(type === 1 ? `/api/app/Formal_Vacuna/${id}/` : `/api/app/Funcional_Vacuna/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new VaccinesServices();
